import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./card_slide.css";
import { Button } from "@mantine/core";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Tooltip,
} from "@material-tailwind/react";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShoppingCart,
} from "react-icons/ai";
// export const SlideData = [
//   {
//     id: 1,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03919.jpg?alt=media&token=69e7de87-ad90-47af-bdb8-68d43d93a2ff",
//   },
//   {
//     id: 2,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03536.jpg?alt=media&token=33ab8155-fdca-4a32-a2a1-caa2263c60f3",
//   },
//   {
//     id: 3,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01351.jpg?alt=media&token=8c2672bc-8621-45f8-b689-dbbf66d06aba",
//   },
//   {
//     id: 4,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP00956.jpg?alt=media&token=72e8d8f1-c039-441a-8343-b42cc032a2e0",
//   },
//   {
//     id: 5,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01327.jpg?alt=media&token=08fcfc23-e407-40eb-bc13-8f9ffdbde0c5",
//   },
//   {
//     id: 6,
//     name: "something",
//     cate: "recom",
//     img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01028.jpg?alt=media&token=cd63e31d-6c4f-4898-ba54-5170ffc8a36a",
//   },
// ];
const NextArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-right-10 shadow-md bg-white p-4 rounded-full md:right-4 top-[47%]"
    >
      <AiOutlineArrowRight />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-left-10 shadow-md bg-white p-4 rounded-full md:-left-10 left-3 z-10 top-[47%] "
    >
      <AiOutlineArrowLeft />
    </div>
  );
};

const CardSlide = ({ SlideData }) => {
  const [defaultImage, setDefaultImage] = useState({});
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
    ],
  };

  const handleErrorImage = (data) => {
    setDefaultImage((prev) => ({
      ...prev,
      [data.target.alt]: data.target.alt,
      linkDefault: "",
    }));
  };

  return (
    <div className="  mb-10">
      <Slider {...settings}>
        {SlideData.map((item) => (
          <a
            href="https://yourstylistclothing.com/"
            className="w-96 relative shadow-none"
            key={item.id}
          >
            <div className="absolute top-6 right-6 cursor-pointer z-50 p-2 hover:scale-110 transition-all bg-white rounded-full">
              <AiOutlineShoppingCart />
            </div>
            <div className="h-80 rounded-none">
              <img
                src={item.img}
                alt="profile-picture"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="text-start pl-1">
              <div variant="" color="blue-gray" className="mb-0 font-light">
                {item.name}
              </div>
              <div color="blue" className="font-medium text-xs">
                {item.cate}
              </div>
            </div>
          </a>
        ))}
      </Slider>
    </div>
  );
};

export default CardSlide;
